import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { QuickLinks as QuickLinksComponent } from "../../sharedComponents/QuickLinks";
import * as styles from "./QuickLinks.module.scss";

const QuickLinks = ({ links }) => (
	<QuickLinksComponent
		links={links}
		classNames={{
			btn: styles.btn,
			btnIcon: styles.btnIcon,
		}}
	/>
);

QuickLinks.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
			to: PropTypes.string.isRequired,
			invertButtonStyle: PropTypes.bool,
		})
	),
};
QuickLinks.defaultProps = {
	links: null,
};

export default QuickLinks;
export { QuickLinks };
